<div *ngIf="character" class="sheet">
	<app-name class="section"></app-name>
	<div class="upper-wrap">
		<app-background class="sub-section" [character]="character"></app-background>
		<app-vitals class="sub-section" [vitals]="character.vitals"></app-vitals>
	</div>

	<app-attributes [attributes]="character.attributes"></app-attributes>
	<app-passive-perception [character]="character"></app-passive-perception>

	<div class="inspiration-wrap section-wrapper">
			<app-inspiration class="section"></app-inspiration>
			<app-proficiency-bonus class="section" [bonus]="character.proficiencies.proficiencyBonus"></app-proficiency-bonus>
	</div>
	<app-saving-throws class="sub-section" [character]="character"></app-saving-throws>
	<app-skills class="sub-section" [character]="character"></app-skills>
	<app-armorclass [character]="character" class="sub-section"></app-armorclass>
	<app-hitpoints [hitpoints]="character.hitpoints" class="sub-section"></app-hitpoints>
	<app-hitdice [hitdice]="character.hitDice" class="sub-section"></app-hitdice>
	<div class="weapons-wrap section-wrapper">
		<app-weapons [weapons]="character.weapons" class="section"></app-weapons>
		<app-ammunition [ammunition]="character.ammunition" class="section"></app-ammunition>
	</div>
	<app-extra-profs class="section" [proficiencies]="character.proficiencies"></app-extra-profs>
	<app-currency class="section" [currency]="character.currency"></app-currency>
	<app-equipment class="section" [equipment]="character.equipment"></app-equipment>
	<app-notes class="section" [notes]="character.notes"></app-notes>
</div>

<div class="navigation">
	<button type="button"
			(click)="toBuilder()"
			[innerText]="'Builder'"
	></button>

	<button type="button"
					(click)="exportCharacter()"
					[disabled]="true"
					[class.disabled]="true"
					[innerText]="'Export Character'"
	></button>

	<button type="button"	(click)="debug()">Debug</button>
	<button type="button"	(click)="test()">Test</button>
</div>